import React from "react";
import { makeStyles } from "tss-react/mui";

import { Box } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    row: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(1),
        height: 50,
    },
}));

export const FileActionsRow = ({ children }: React.PropsWithChildren) => {
    const { classes } = useStyles();
    return <Box className={classes.row}>{children}</Box>;
};
